import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function CoachingPage() {
  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-amber-900 via-amber-800 to-amber-950 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9nPjwvc3ZnPg==')] opacity-20"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-6">
          <div className="mb-6">
            <span className="inline-block bg-amber-700/50 text-amber-100 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider">
              / EDUCATION /
            </span>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
                Master the Art of<br />Short-Term Rental Hosting
              </h1>
              <p className="text-xl text-white/90 mb-8 leading-relaxed">
                Learn the proven systems and strategies that helped us maintain a 4.95 rating in Lagos and manage 15+ successful properties. Build your own profitable STR business with expert guidance.
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
              <div className="relative h-64 rounded-lg overflow-hidden mb-6">
                <img
                  src="https://public.readdy.ai/ai/img_res/9f6abb05b4dace7d9889b65e8f9b18a8.jpg"
                  alt="Coaching Session"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="text-center">
                <div className="text-6xl font-bold text-white mb-2">100+</div>
                <p className="text-white/80 mb-6">Hosts Trained & Coached</p>
                <Link
                  to="/get-started"
                  className="inline-flex items-center px-8 py-3 bg-white text-amber-900 rounded-full text-base font-medium hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer w-full justify-center"
                >
                  Apply for Coaching
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Coaching Programs */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Our Coaching Programs
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Choose the program that fits your goals and experience level
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Listing Optimization Coaching */}
            <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-amber-500 hover:shadow-xl transition-all">
              <div className="w-14 h-14 bg-amber-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-file-list-3-line text-3xl text-amber-900"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Listing Optimization</h3>
              <p className="text-gray-600 mb-6">
                Perfect for existing hosts who want to improve their listing performance and increase bookings.
              </p>
              
              <ul className="space-y-3 mb-8">
                <li className="flex items-start text-sm">
                  <i className="ri-check-line text-emerald-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Comprehensive listing audit</span>
                </li>
                <li className="flex items-start text-sm">
                  <i className="ri-check-line text-emerald-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Photo and description optimization</span>
                </li>
                <li className="flex items-start text-sm">
                  <i className="ri-check-line text-emerald-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Pricing strategy development</span>
                </li>
                <li className="flex items-start text-sm">
                  <i className="ri-check-line text-emerald-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>SEO and visibility tactics</span>
                </li>
                <li className="flex items-start text-sm">
                  <i className="ri-check-line text-emerald-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>2 one-on-one sessions</span>
                </li>
              </ul>

              <div className="mb-6">
                <span className="text-3xl font-bold text-gray-900">$497</span>
                <span className="text-gray-600"> / one-time</span>
              </div>

              <Link
                to="/get-started"
                className="block w-full text-center px-6 py-3 bg-gray-900 text-white rounded-full text-sm font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Started
              </Link>
            </div>

            {/* STR Business Launch */}
            <div className="bg-amber-900 rounded-2xl p-8 text-white relative overflow-hidden transform scale-105 shadow-2xl">
              <div className="absolute top-4 right-4">
                <span className="bg-amber-700 text-white px-3 py-1 rounded-full text-xs font-bold">
                  MOST POPULAR
                </span>
              </div>
              
              <div className="w-14 h-14 bg-white/20 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-rocket-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">STR Business Launch</h3>
              <p className="text-amber-100 mb-6">
                Complete program for new hosts or investors starting their STR business from scratch.
              </p>
              
              <ul className="space-y-3 mb-8">
                <li className="flex items-start text-sm">
                  <i className="ri-check-line text-amber-300 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span className="text-amber-50">Property selection guidance</span>
                </li>
                <li className="flex items-start text-sm">
                  <i className="ri-check-line text-amber-300 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span className="text-amber-50">Market analysis and research</span>
                </li>
                <li className="flex items-start text-sm">
                  <i className="ri-check-line text-amber-300 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span className="text-amber-50">Complete setup roadmap</span>
                </li>
                <li className="flex items-start text-sm">
                  <i className="ri-check-line text-amber-300 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span className="text-amber-50">Furnishing and design consultation</span>
                </li>
                <li className="flex items-start text-sm">
                  <i className="ri-check-line text-amber-300 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span className="text-amber-50">Operations systems setup</span>
                </li>
                <li className="flex items-start text-sm">
                  <i className="ri-check-line text-amber-300 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span className="text-amber-50">6 one-on-one sessions</span>
                </li>
                <li className="flex items-start text-sm">
                  <i className="ri-check-line text-amber-300 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span className="text-amber-50">90 days email support</span>
                </li>
              </ul>

              <div className="mb-6">
                <span className="text-3xl font-bold">$1,497</span>
                <span className="text-amber-200"> / one-time</span>
              </div>

              <Link
                to="/get-started"
                className="block w-full text-center px-6 py-3 bg-white text-amber-900 rounded-full text-sm font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Started
              </Link>
            </div>

            {/* Performance Audit */}
            <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-amber-500 hover:shadow-xl transition-all">
              <div className="w-14 h-14 bg-emerald-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-bar-chart-box-line text-3xl text-emerald-900"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Performance Audit</h3>
              <p className="text-gray-600 mb-6">
                Deep-dive analysis of your current operations with actionable recommendations for improvement.
              </p>
              
              <ul className="space-y-3 mb-8">
                <li className="flex items-start text-sm">
                  <i className="ri-check-line text-emerald-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Complete performance analysis</span>
                </li>
                <li className="flex items-start text-sm">
                  <i className="ri-check-line text-emerald-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Revenue optimization strategy</span>
                </li>
                <li className="flex items-start text-sm">
                  <i className="ri-check-line text-emerald-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Operational efficiency review</span>
                </li>
                <li className="flex items-start text-sm">
                  <i className="ri-check-line text-emerald-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Detailed action plan</span>
                </li>
                <li className="flex items-start text-sm">
                  <i className="ri-check-line text-emerald-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>1 strategy session</span>
                </li>
              </ul>

              <div className="mb-6">
                <span className="text-3xl font-bold text-gray-900">$297</span>
                <span className="text-gray-600"> / one-time</span>
              </div>

              <Link
                to="/get-started"
                className="block w-full text-center px-6 py-3 bg-gray-900 text-white rounded-full text-sm font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* What You'll Learn */}
      <section className="py-24 bg-amber-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">
            What You'll <span className="text-amber-900">Learn</span>
          </h2>
          <p className="text-center text-gray-600 mb-16 max-w-2xl mx-auto">
            Our coaching programs cover everything you need to build and scale a successful STR business
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-search-line text-2xl text-amber-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Property Selection</h3>
              <p className="text-gray-600 text-sm">
                Learn how to identify profitable properties and analyze market potential before investing.
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-price-tag-3-line text-2xl text-emerald-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Pricing Strategies</h3>
              <p className="text-gray-600 text-sm">
                Master dynamic pricing techniques to maximize revenue while maintaining high occupancy.
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-image-line text-2xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Listing Optimization</h3>
              <p className="text-gray-600 text-sm">
                Create compelling listings with professional photos and descriptions that convert browsers to bookers.
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-customer-service-2-line text-2xl text-purple-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Guest Experience</h3>
              <p className="text-gray-600 text-sm">
                Deliver 5-star experiences that generate positive reviews and repeat bookings.
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-settings-3-line text-2xl text-red-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Operations Systems</h3>
              <p className="text-gray-600 text-sm">
                Build efficient systems for cleaning, maintenance, and guest communication that scale.
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-line-chart-line text-2xl text-orange-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Growth & Scaling</h3>
              <p className="text-gray-600 text-sm">
                Strategies for expanding your portfolio and building a sustainable STR business.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Our Coaching */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Why Our Coaching Works
              </h2>
              <p className="text-lg text-gray-600 mb-8">
                We don't teach theory—we share the exact systems we use to manage 15+ properties and maintain exceptional ratings in challenging markets.
              </p>

              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-shield-check-line text-2xl text-amber-900"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Battle-Tested Systems</h3>
                    <p className="text-gray-600">
                      Our methods were developed and refined in Lagos—one of the most operationally challenging cities for STRs.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-user-star-line text-2xl text-emerald-900"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Personalized Guidance</h3>
                    <p className="text-gray-600">
                      One-on-one sessions tailored to your specific property, market, and goals.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-trophy-line text-2xl text-blue-900"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Proven Results</h3>
                    <p className="text-gray-600">
                      Our coaching clients see measurable improvements in occupancy, revenue, and guest satisfaction.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="relative h-[600px] rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=professional-airbnb-coach-presenting-business-strategy-on-whiteboard-with-revenue-charts-and-growth-metrics-modern-bright-training-room-with-engaged-students-taking-notes-successful-hospitality-education-environment&width=700&height=900&seq=coaching-why-choose&orientation=portrait"
                  alt="Coaching Session"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Application CTA */}
      <section className="py-24 bg-gradient-to-br from-amber-900 to-amber-950">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Build Your STR Business?
          </h2>
          <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
            Apply for coaching and start learning the systems that work in any market
          </p>
          <Link
            to="/get-started"
            className="inline-flex items-center px-10 py-4 bg-white text-amber-900 rounded-full text-lg font-medium hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
          >
            Apply for Coaching
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}